module.exports = __webpack_public_path__ + "img/tk.707d9847.png";